import React from 'react'

import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { Icon } from '@mxenabled/mxui'

interface DebtsPrioriyButtonProps {
  buttonText: string
  disabled?: boolean
  isDesktop?: boolean
  isOpen: boolean
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const DebtsPriorityButton = ({
  buttonText,
  disabled,
  isDesktop = false,
  isOpen,
  onClick,
}: DebtsPrioriyButtonProps) => {
  const icon = isOpen ? 'unfold_less' : 'unfold_more'

  return isDesktop ? (
    <Button
      aria-controls="prioritize-debts"
      aria-describedby="prioritize-debts"
      aria-haspopup={true}
      aria-label="prioritize-debts"
      disabled={disabled}
      onClick={onClick}
      startIcon={<Icon name={icon} />}
      sx={{ justifyContent: 'start' }}
    >
      {buttonText}
    </Button>
  ) : (
    <IconButton
      aria-controls="prioritize-debts"
      aria-describedby="prioritize-debts"
      aria-haspopup={true}
      aria-label="prioritize-debts"
      disabled={disabled}
      onClick={onClick}
    >
      <Icon name={icon} />
    </IconButton>
  )
}
